import Lenis from 'lenis'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

function lenisScroll() {
  const lenis = new Lenis({
    autoRaf: false,
    smoothWheel: true,
    wheelMultiplier: 1,
    duration: 1,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothTouch: false, // Mobile
    touchMultiplier: 2, // sensibility on mobile
    infinite: false, // Infinite scrolling
    prevent: (node) => {
      // Excluir modal-box y sus descendientes
      if (node.classList.contains('modal-box') || node.closest('.modal-box')) {
        return true;
      }
      // Excluir contenedores con scroll interno (.opciones y elementos con overflow-y-auto)
      if (node.classList.contains('lenis-box') || node.closest('.lenis-box')) {
        return true;
      }
      return false;
    }
  })

  // Store the lenis instance on the window object for use in other modules
  window.lenisInstance = lenis

  const smoothLinks = document.querySelectorAll('.anchor')

  smoothLinks.forEach(link => {
    const anchor = link.getAttribute('href')
    link.addEventListener('click', (e) => {
      e.preventDefault()
      // lenis.scrollTo(anchor)
      // anchor.scrollIntoView({ behavior: 'smooth' })

      lenis.scrollTo(anchor, {
        duration: 2, // Puedes ajustar la duración según tus necesidades
        easing: (t) => 1 - Math.pow(1 - t, 6) // Ejemplo de una función de easing personalizada
      })
    })
  })

  // Sync Lenis → ScrollTrigger
  lenis.on('scroll', ScrollTrigger.update)

  // Use GSAP ticker instead of manual RAF (single unified loop)
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000)
  })
  gsap.ticker.lagSmoothing(0)
}

export default lenisScroll
